import { useState, useEffect } from "react";
import * as R from "ramda";
import { fcmApi } from "../../services/Api";

export const useClientHaveFcm = (clientId) => {
  const [state, setState] = useState(null);

  const fetchFcmByClientId = async () => {
    const response = await fcmApi.getFcmsByClientId(clientId);

    if (response.ok && R.isEmpty(response.data)) {
      setState("Cliente ainda sem aparelho registrado para notificação");
    } else {
      setState(null);
    }
  };

  useEffect(() => {
    fetchFcmByClientId();
  }, []);

  return state;
};

export const useCustomClientHaveFcm = (apiGetCall) => {
  const [state, setState] = useState(null);

  const fetchFcmByClientId = async () => {
    const apiCallResponse = await apiGetCall;
    let response = null;

    if (apiCallResponse.ok)
      response = await fcmApi.getFcmsByClientId(apiCallResponse.data.clienteId);

    if (response && response.ok && R.isEmpty(response.data)) {
      setState("Cliente ainda sem aparelho registrado para notificação");
    } else {
      setState(null);
    }
  };

  useEffect(() => {
    fetchFcmByClientId();
  }, []);

  return state;
};
